<template>
    <div>
        <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>

        <div class="register">
            <Row :gutter="10" class="top">
                <Col span="18">
                <div class="title">The 26th China Hospital Construction
                    Conference International Hospital
                    Build and Infrastructure Exposition</div>
                </Col>
                <Col span="6" class="f-tar">
                <Button shape="circle" style="margin-left:10px"
                    @click="$router.push(`/ex-register/register-mobile`)">中文</Button>
                </Col>
            </Row>
            <registerForm ref="registerForm"></registerForm>
            <!-- <registerAddr ref="registerAddr"></registerAddr> -->

            <div class="f-tac submit-btn">
                <Button type="primary" size="large" @click="handleSubmit" :loading="loading">Submit an
                    application</Button>
            </div>

            <!-- <div class="tip-info">
                <p>Remarks：</p>
                <p>Please kindly note that this is an application form not a contract. There is a chance that you may
                    not be allotted the size of stand which you desire.</p>
            </div> -->
        </div>
    </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
    name: 'register',
    components: {
        registerForm,
        registerAddr,
        gSwiper,
    },
    props: {},
    data() {
        return {
            loading: false,
            // arr: [{ id: 1, path: require('../../../../assets/img/banner.png') }],
            arr: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/files/202409/9e6c2f16171647fea3719eed80247b18.jpg' }],

        };
    },
    watch: {},
    computed: {},
    methods: {
        ...mapActions({
            getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
        }),
        async handleSubmit() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 5000);
            let res = await this.$refs.registerForm.handleSubmit();
            this.loading = false;
            if (!res.valid) return;
            // let res1 = await this.$refs.registerAddr.handleSubmit();
            // console.log('registerForm', res);
            // console.log('res1', res1);
            // console.log('registerAddr', res2);
            let opt = {
                newCompany: { ...res.form },
                lists: [{
                    // exhibitionId: '71F993FB-03A8-4EB3-A3F0-65C9D2D665F3',
                    exhibitionId: 'EFC0A7EC-B2F0-4EF6-9ED4-8114CFD528DB',
                    ...res.lists[0]
                }],
                reportType: 'en'
            };
            // if(res1.lists.length>0){
            //     res1.lists[0].exhibitionId="916139F0-4A1E-4C53-983B-F9BCCC4897CC"
            //     opt.lists.push(res1.lists[0])
            // }
            // let exname = '';
            // res2.exhibition.forEach((c, index) => {
            //     exname += c.nameEn;
            //     if (res2.exhibition.length !== index + 1) {
            //         exname += ','
            //     }
            // });

            console.log('option', opt);
            let bool = await this.getApplyCompanyRoastCreate(opt);
            console.log('getApplyCompanyRoastCreate', bool);
            if (bool && bool.successed) {
                let query = 'company=' + encodeURI(res.form.companyNameEn);
                this.$router.push(`/ex-register-en/register-result?${query}`);
            } else {
                let errTxt = bool.msg || bool.info || "error,try again";
                if (bool.errors && bool.errors[0] && bool.errors[0].description) {
                    errTxt = bool.errors[0].description;
                }
                this.$Message.error(errTxt);
            }

        },
        IsPC() {
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
    },
    created() {
        if (this.IsPC()) {
            this.$router.push(`/ex-register-en/register`);
        }
        document.title = "CHCC booth application";
    },
    mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
    max-width: 1200px;
    margin: 0 auto;

    .top {
        padding: 15px;
    }

    .title {
        font-size: 13px;
        color: #1e88e5;
        font-weight: bold;
        line-height: 15px;
    }
}

.submit-btn {
    margin-top: 50px;
    text-align: center;

    button {
        padding: 0 46px;
        background-color: #1e88e5;
        font-size: 16px;
        border-color: #1e88e5;
        margin-bottom: 30px;
        height: 40px;
        border-radius: 20px;
        font-size: 15px;
        color: #fff;
    }
}

.tip-info {
    margin: 50px auto;
    padding: 15px;
    white-space: nowrap;

    p {
        font-size: 12px;
        color: #666;
        margin-bottom: 4px;
        white-space: normal;
    }
}
</style>
